/**
 * Shared helper: resolve an entry line type to an i18n label key.
 *
 * The side (customer vs provider) is deduced from the document_number prefix:
 *   C- → customer, P- → provider.
 * When no prefix is available (old entries without document_number),
 * defaults to the customer variant.
 *
 * Used by EntryView, ContactEntry and JournalView.
 */
export function entryTypeLabelKey(type?: string | null, document_number?: string | null): string {
  const side = document_number?.startsWith('C-') ? 'customer'
             : document_number?.startsWith('P-') ? 'provider' : null

  switch (type) {
    case 'interest':         return side === 'provider' ? 'providerInterest'   : 'customerInterest'
    case 'penalty':          return side === 'provider' ? 'providerPenalty'    : 'customerPenalty'
    case 'refund':           return side === 'provider' ? 'providerRefund'     : 'customerRefund'
    case 'payment':          return side === 'provider' ? 'providerPayment'    : 'customerPayment'
    case 'credit-note':      return side === 'provider' ? 'providerCreditNote' : 'customerCreditNote'
    case 'invoice':          return 'invoice'
    case 'provider-invoice': return 'providerInvoice'
    case 'expense':          return 'expense'
    case 'reminder':         return 'reminder'
    case 'order':            return 'order'
    case 'provider-order':   return 'providerOrder'
    case 'quote':            return 'quote'
    default:                 return 'manualEntry'
  }
}
